import {keyPresses} from '../Library/Keyboard';

const initializedTabLists = new WeakSet();

export const initializeTabs = root => {
    root.querySelectorAll('.tabbed-content-container .tabs-nav li.active').forEach(activeTab => {
        const parent = activeTab.parentElement;

        if (initializedTabLists.has(parent)) {
            return;
        }

        initializedTabLists.add(parent);

        activeTab.scrollIntoView({
            block: 'nearest',
            inline: 'end',
        });

        parent.addEventListener('wheel', event => {
            if (keyPresses['Shift']) {
                return;
            }

            parent.scrollLeft += event.deltaY > 0 ? 25 : -25;

            if (window.getComputedStyle(parent).getPropertyValue('flex-direction') === 'column') {
                return;
            }

            event.preventDefault();
        });
    });
};
